import { TestGraph } from "../../../types";
import { graphConfig } from "./config";
import { GraphSize } from "./index";

type Props = {
    size: GraphSize;
    graphData: TestGraph;
};

type ColorsListKey = `${"response" | "slope"}${1 | 2 | 3}_other_statuses`;
type StatusKey = `${"response" | "slope"}${1 | 2 | 3}_status`;

const GraphLeftSideTitles = ({ size, graphData }: Props) => {
    const hasSecondGraph = !!graphData.response2_xy;
    const hasThirdGraph = !!graphData.response3_xy;
    const isSmall = size === "sm";

    const colorsListKey: ColorsListKey = graphData.response1_status
        ? "response1_other_statuses"
        : "slope1_other_statuses";
    const statusKey: StatusKey = graphData.response1_status
        ? "response1_status"
        : "slope1_status";

    return (
        <div
            style={{
                position: "absolute",
                top:
                    hasThirdGraph && isSmall
                        ? 0
                        : graphConfig.position[size].top,
                bottom:
                    hasThirdGraph && isSmall
                        ? 20
                        : graphConfig.position[size].bottom,
                left: size === "sm" ? "6px" : "12px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: hasThirdGraph
                    ? isSmall
                        ? "space-evenly"
                        : "space-around"
                    : "center",
                whiteSpace: "nowrap",
            }}
            className={`${graphConfig.size[size].texts.className}`}
        >
            <div className="relative rotate-[-90deg] order-1 flex items-center gap-2.5">
                {hasSecondGraph && (
                    <div
                        style={{
                            borderRadius: "100%",
                            left: graphConfig.dot[size].left,
                            width: graphConfig.dot[size].size,
                            height: graphConfig.dot[size].size,
                            backgroundColor:
                                graphData[colorsListKey]?.find(
                                    (status) =>
                                        status.status ===
                                        graphData[statusKey]
                                )?.status_color ||
                                graphData.response1_status_color ||
                                graphData.response1_label_color,
                        }}
                    />
                )}
                {graphData.response1_y_label}
            </div>
            {hasThirdGraph && (
                <div className="relative rotate-[-90deg] flex items-center gap-2.5">
                    <div
                        style={{
                            display: hasSecondGraph ? "block" : "none",
                            borderRadius: "100%",
                            left: graphConfig.dot[size].left,
                            width: graphConfig.dot[size].size,
                            height: graphConfig.dot[size].size,
                            backgroundColor:
                                graphData.response3_label_color ||
                                graphData.response3_status_color,
                        }}
                    />
                    {graphData.response3_y_label}
                </div>
            )}
        </div>
    );
};

export default GraphLeftSideTitles;
